module.exports = __webpack_public_path__ + "media/images/mypage/icon/white/ico_check-2789c90943868a33c0ce2eb52fd06de6.svg";